import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-100 text-[#4f3af6] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 1200 400">
          <path
            d="M0,200 Q300,150 600,200 T1200,200"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://static.readdy.ai/image/c35406c68f4851f7123e42c3a05fcb72/7284a9e366c89bc3def167baae8f05df.png" 
                alt="SEOPower AI SEO Software – Brand Logo" 
                className="h-8 w-auto"
              />
              <span className="text-xl font-bold">SEOPower.co</span>
            </div>
            <p className="text-3xl font-serif mb-6 leading-tight">
              Optimize Smarter,<br />Rank Faster
            </p>
          </div>

          <div>
            <h4 className="font-bold mb-4">Product</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-[#4f3af6]/70 hover:text-[#4f3af6] transition-colors cursor-pointer">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/purchase" className="text-[#4f3af6]/70 hover:text-[#4f3af6] transition-colors cursor-pointer">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4">Resources</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/guide" className="text-[#4f3af6]/70 hover:text-[#4f3af6] transition-colors cursor-pointer">
                  Guides
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4">Support</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/support" className="text-[#4f3af6]/70 hover:text-[#4f3af6] transition-colors cursor-pointer">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#4f3af6]/20 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-[#4f3af6]/70">
            © 2025 SEOPower.co. All rights reserved.
          </p>

          <div className="flex items-center gap-4">
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-[#4f3af6]/30 hover:bg-[#4f3af6]/10 transition-colors cursor-pointer"
            >
              <i className="ri-linkedin-fill text-lg"></i>
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-[#4f3af6]/30 hover:bg-[#4f3af6]/10 transition-colors cursor-pointer"
            >
              <i className="ri-twitter-x-fill text-lg"></i>
            </a>
            <a
              href="https://www.facebook.com/groups/1263439799313873"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-[#4f3af6]/30 hover:bg-[#4f3af6]/10 transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-lg"></i>
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-[#4f3af6]/30 hover:bg-[#4f3af6]/10 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-fill text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
